// import logo from './logo.svg';
import './App.css';
// aquí hay que importar los tres componentes que hemos creado
import {Home} from './Home';
import {Genero} from './Genero';
import {Libro} from './Libro';
// también los módulos que necesitamos por el routing
import { BrowserRouter, Route, Switch, NavLink } from 'react-router-dom';
// aquí debajo tras el cierre del h3 y antes del del div

function App() {
  return (
   <BrowserRouter>

    {/* // aquí quitamos todo y añadimos saludo */}
    <div className="App container"> 
      <h3 className="d-flex justify-content-center m-3">
       {/* se cambia todo al momento en el navegador  Hola mundo*
        ahora hay que ir al public/index.html y añadir bootstsrap Mirar allí arriba*/}
        Libros catálogo por géneros
      </h3>
 {/* añadimos el navegador hacia las tres páginas los nombres
 las clases son de bootstsrap debajo del cierre del nav colocamos una etiqueta switch*/}
      <nav className="navbar navbar-expand-sm bg-light navbar-dark">
        <ul className="navbar-nav">
          <li className="nav-item- m-1">
            <NavLink className="btn btn-light btn-outline-primary" to="/home">
              Home
            </NavLink>
          </li>
          <li className="nav-item- m-1">
            <NavLink className="btn btn-light btn-outline-primary" to="/genero">
              Genero
            </NavLink>
          </li>
          <li className="nav-item- m-1">
            <NavLink className="btn btn-light btn-outline-primary" to="/libro">
              Libro
            </NavLink>
            </li>
        </ul>
      </nav>
      {/* aquí si es donde se indica cada uno de los componentes 
      (en mayúsculas, como el archivo) hacemos recordar que cd my-app (o el nombre de la app)
      hay también que bajar la versión del react-router-dom porque el Switch no funcionará 
      >> npm install react-router-dom@5.2.0
      >> npm start 
      y vemos si va : las rutas en la url cambian, pero a menos que no demos en la url no renderiza el componente
      vamos a seguir igual:creamos un archivo donde guardar nuestros endpoints Variables.js Y vamos allí*/}
      
      <Switch>
        <Route path='/home' component={Home}/>
        <Route path='/genero' component={Genero}/>
        <Route path='/libro' component={Libro}/>
      </Switch>
  
    </div>
    {/* // hay que rodear todo el return con etiqueta   <BrowserRouter> */}
       </BrowserRouter>
 
  );
}

export default App;
